import { render, staticRenderFns } from "./center-business.vue?vue&type=template&id=1043fa30&"
import script from "./center-business.vue?vue&type=script&lang=js&"
export * from "./center-business.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports